import React from 'react';
import { Form, Select } from 'antd';
import { AssignmentSelectFragmentType } from '@pay-bill/graphql';
import { toUSCompactDateFormat } from 'works/legacy/lib/date-helper';

const dropdownStyle = { minWidth: '35%' };

export const AssignmentSelect = ({
  assignments,
}: {
  assignments: AssignmentSelectFragmentType[];
}) => (
  <Form.Item
    label="Name"
    name="staffingRequestAssignmentId"
    rules={[{ required: true }]}
  >
    <Select
      size="large"
      showSearch={true}
      optionFilterProp="children"
      placeholder="Select Name"
      dropdownStyle={dropdownStyle}
      filterOption={(input, option) =>
        option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {assignments.map(
        ({ id, startDate, endDate, worksProfile, organizationProfile }) => {
          const formattedStartDate = toUSCompactDateFormat(startDate);
          const formattedEndDate = toUSCompactDateFormat(endDate);
          const employeeId = organizationProfile.employeeId || 'Blank';
          const name = `${worksProfile.firstName} ${worksProfile.lastName} (${employeeId}) - ${formattedStartDate}–${formattedEndDate}`;

          return (
            <Select.Option
              key={id}
              value={id}
              title={name}
              className="select-option"
            >
              {name}
            </Select.Option>
          );
        }
      )}
    </Select>
  </Form.Item>
);
